(function(window, undefined) {

    'use strict';


    /**
     * Video slider component
     */


    var Css   = SAPO.Dom.Css,
        Event = SAPO.Dom.Event,
        Ut    = SAPO.Utility;



    var genId = function() {
        return 'cue_' + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };



    var fixBoundingClientRect = function(bcr, prop) {
        var val = bcr[prop];
        if (isNaN(val)) {
            if (prop === 'width') {
                return bcr.right - bcr.left + 1;
            }
            else if (prop === 'height') {
                return bcr.bottom - bcr.top + 1;
            }
        }
        return val;
    };



    /**
     * CSS classes: done, handle, cue*
     */

    var Slider = function(o) {
        this._o = SAPO.extendObj({
            min:              0,
            max:              1,
            offsetAttr:       'left',
            sizeAttr:         'width',
            axis:             'x',
            disableScrubbing: false
        }, o || {});

        this._v = ( (this._o.value === undefined) ? this._o.min : this._o.value);
        this._l = this._o.max - this._o.min;
        delete this._o.value;
        this._isDown = false;
        this._scrubbing = !this._o.disableScrubbing;

        this._backedUpCues = {};
        this._currentCues  = {};

        this._doneEl   = this._o.doneElement;
        this._handleEl = this._o.handleElement;
        this._tickEl   = this._o.tickElement;

        this.setValue(this._v);

        this._updateBounds();



        // touch events
        var s = this;
        var ctn = this._o.container;

        var on = function(ev) {
            if (!s._scrubbing) { return; }

            var p, v;

            if ( (ev.type === 'mousemove' || ev.type === 'touchmove') /*&& !s._isDown*/) {
                if (s._tickEl) {
                    if(s._size  === 0 || s._size  === 1) {
                        s._updateBounds();
                    }
                    //Event.stopDefault(ev); // TODO: REMOVE THIS LINE TO GO TO 21C AND FIX MOBILE SCROLL

                    p = Event.pointer(ev);
                    v = s._getValueFromPointer(p, true);

                    if (s._o.onUpdateTick) {
                        s._o.onUpdateTick.call(s, p, v);
                    }
                    else {
                        s._tickEl.style[ s._o.offsetAttr ] = (v * 100).toFixed(2) + '%';
                    }
                }
                if (!s._isDown) {
                    return ;
                }
            }

            Event.stop(ev);
            p = Event.pointer(ev);

            if (ev.type === 'mousedown' || ev.type === 'touchstart') {
                if (s._o.onStart) {
                    s._o.onStart.call(s);
                }

                var bcr = ctn.getBoundingClientRect();
                var tmpOff = fixBoundingClientRect(bcr, s._o.offsetAttr);
                var tmpSz  = fixBoundingClientRect(bcr, s._o.sizeAttr  );
                s._offset = tmpOff;
                s._size   = tmpSz;
                s._isDown = true;
            }

            s.setValue( s._getValueFromPointer(p), true );

            if (s._o.onChanging) {
                s._o.onChanging.call(s);
            }
        };

        var off = function(ev) {
            if (!s._isDown || !s._scrubbing) { return; }

            Event.stop(ev);

            //Css.removeClassName(ctn, 'being-dragged');

            s._isDown = false;

            if (s._o.onChange) {
                s._o.onChange.call(s);
            }
        };

        var docEl = document.documentElement;
        Event.observe(ctn,   'mousedown',  on);
        Event.observe(docEl, 'mousemove',  on);
        Event.observe(docEl, 'mouseup',    off);

        Event.observe(ctn,   'touchstart', on);
        Event.observe(docEl, 'touchmove',  on);
        Event.observe(docEl, 'touchend',   off);
    };

    Slider.prototype = {
        changeLimits: function(min, max) {
            this._o.min = min;
            this._o.max = max;
            this._l = max - min;

            this._updateBounds();

            //console.log('MAX:', max);

            this.setValue(this._v);

            this.backupCues('tmp');
            this.removeCues();
            this.restoreCues('tmp');
        },

        getValue: function() {
            return this._v;
        },

        setValue: function(v, force) {
            if (this._isDown && !force) { return; }

            if      (v < this._o.min) { v = this._o.min; }
            else if (v > this._o.max) { v = this._o.max; }

            this._v = v;
            var vv = this._toRatio(v);
            var pct = this._toPercent(vv);

            if (!this._o.skipDone) {
                this._doneEl.style[ this._o.sizeAttr ] = pct;
            }

            this._handleEl.style[ this._o.offsetAttr ] = pct;
        },

        setScrubbing: function(v) {
            Css.setClassName(this._o.container, 'disabled', !v);
            this._scrubbing = !!v;
        },



        // value, [id], [title], [color], [width]
        addCue: function(o) {
            var id;
            if (o.id) {
                id = o.id;
            }
            else {
                o.id = id = genId();
            }

            var cueEl = document.createElement('div');
            cueEl.className = 'cue';
            cueEl.id = id;
            cueEl.style[ this._o.offsetAttr ] = this._toPercent(o.value, true);

            //console.log('addCue   title:', o.title, '  value:', o.value, '  duration:', this._o.max, '  percent:', cueEl.style.left);

            if (o.title) {
                cueEl.title = o.title;
            }
            if (o.color) {
                cueEl.style.backgroundColor = o.color;
            }
            if (o.width) {
                cueEl.style[ this._o.sizeAttr ] = o.width + 'px';
            }

            this._o.container.insertBefore(cueEl, this._handleEl);

            this._currentCues[id] = o;

            return id;
        },

        removeCue: function(cueId) {
            delete this._currentCues[cueId];
            var cueEl = document.getElementById(cueId);
            if (!cueEl) { return false; }
            this._o.container.removeChild(cueEl);
            return true;
        },

        removeCues: function() {
            var cueEl, cueEls = Ut.getElementsByClassName('cue', this._o.container);
            for (var i = cueEls.length - 1; i >= 0; --i) {
                cueEl = cueEls[i];
                this._o.container.removeChild( cueEl );
            }
            this._currentCues = {};
        },

        backupCues: function(storeName) {
            this._backedUpCues[storeName] = this._currentCues;
            this._currentCues = {};
        },

        restoreCues: function(storeName) {
            var t = this._backedUpCues[storeName];

            if (!t) {
                t = {};
                this._backedUpCues[storeName] = t;
            }

            this._currentCues = t;

            for (var id in this._currentCues) {
                if (!this._currentCues.hasOwnProperty(id)) { continue; }
                this.addCue( this._currentCues[id] );
            }
        },



        _updateBounds: function() {
            var bcr = this._o.container.getBoundingClientRect();
            var tmpOff = fixBoundingClientRect(bcr, this._o.offsetAttr);
            var tmpSz  = fixBoundingClientRect(bcr, this._o.sizeAttr  );
            //if (isNaN(tmpOff) || isNaN(tmpSz)) { return; }
            this._offset = tmpOff;
            this._size   = tmpSz;
        },

        _toPercent: function(v, convertToRatioFirst) {
            if (convertToRatioFirst) {
                v = this._toRatio(v);
            }

            if      (v < 0) { v = 0; }
            else if (v > 1) { v = 1; }

            return (v * 100).toFixed(2) + '%';
        },

        _toRatio: function(v) {
            return (v - this._o.min) / this._l;
        },

        _getValueFromPointer: function(p, asRatio) {
            var coord = p[ this._o.axis ] - this._offset;

            if (this._o.offsetAttr === 'bottom') {
                coord *= -1;
            }

            var t = Math.max(0, Math.min(1, coord / this._size) ); // 0 <= coord / size <= 1

            if (asRatio) {
                return t;
            }
            return this._o.min + t * this._l;
        }
    };



    SAPO.namespace('Project.Video.Components');
    SAPO.Project.Video.Components.Slider = Slider;

})(window);
